// extracted by mini-css-extract-plugin
export var ArticleCardBlock = "LastPressArticles-module--ArticleCardBlock--82bcc";
export var articlesCardsContainer = "LastPressArticles-module--articlesCardsContainer--a89ab";